import { useEffect, useState } from "react";

export default function ViewContentOwner({ contentOwner }) {
  const [artistName, setArtistName] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [nric, setNric] = useState("");
  const [payment, setPayment] = useState("");
  const [preferredPayment, setPreferredPayment] = useState("");

  useEffect(() => {
    if (!contentOwner) return;

    setArtistName(contentOwner.artistName || "");
    setName(contentOwner.name || "");
    setMobile(contentOwner.mobile || "");
    setEmail(contentOwner.email || "");
    setAddress(contentOwner.address || "");
    setNric(contentOwner.nric || "");
    setPayment(contentOwner.payment || "");
    setPreferredPayment(contentOwner.preferredPayment || "");
  }, [contentOwner]);

  return (
    <form className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Content Owner Details
      </h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Artist Name
        </label>
        <input
          type="text"
          value={artistName}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Name
        </label>
        <input
          type="text"
          value={name}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Mobile
        </label>
        <input
          type="text"
          value={mobile}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Email
        </label>
        <input
          type="text"
          value={email}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Address
        </label>
        <input
          type="text"
          value={address}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          NRIC
        </label>
        <input
          type="text"
          value={nric}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment
        </label>
        <select
          value={payment}
          disabled
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        >
          <option value="KBZ Bank">KBZ Bank</option>
          <option value="AYA Bank">AYA Bank</option>
          <option value="CB Bank">CB Bank</option>
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Preferred Payment
        </label>
        <select
          value={preferredPayment}
          disabled
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-gray-100 cursor-not-allowed"
        >
          <option value="KBZ Bank">KBZ Bank</option>
          <option value="AYA Bank">AYA Bank</option>
          <option value="CB Bank">CB Bank</option>
        </select>
      </div>
    </form>
  );
}
